import React from "react";
import ticket from "../../../api/ticket";
import WatchPageTutorial from "../../CommonComponents/WatchPageTutorial";

const PlgSupportPage = ({ supportEmail }) => {
  const email = supportEmail || "support@zyratalk.com";
  const mailtoUrl = `mailto:${email}`;

  const handleEmailClick = () => {
    ticket
      .trackPlgSupportEmailClick({ support_email: email })
      .catch((error) => console.error("Error tracking PLG support email click:", error));
  };

  return (
    <div className="plg-support-page">
      <div
        className="alert alert-info d-flex align-items-center"
        style={{
          backgroundColor: "#e7f3ff",
          border: "1px solid #b3d9ff",
          borderRadius: "6px",
          padding: "12px 16px",
          marginBottom: "20px",
        }}
      >
        <i
          className="fa fa-info-circle mr-2"
          aria-hidden="true"
          style={{ fontSize: "28px", color: "#0066cc" }}
        />
        <span style={{ fontSize: "14px", color: "#004085", lineHeight: "1.6" }}>
          For product support, please email{" "}
          <a
            href={mailtoUrl}
            onClick={handleEmailClick}
            target="_blank"
            rel="noreferrer"
            style={{ color: "#0066cc", fontWeight: "500" }}
          >
            {email}
          </a>{" "}
          or navigate to the <strong>Help</strong> section within the app if you
          prefer to chat with support.
        </span>
      </div>

      <div className="d-flex align-items-center justify-content-start" style={{ gap: "12px" }}>
        <a
          href={mailtoUrl}
          onClick={handleEmailClick}
          className="btn linear-gradient yr-add-new d-flex align-items-center justify-content-center"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none", fontSize: "1rem", fontWeight: "400" }}
        >
          <i className="fa fa-envelope-o mr-2" aria-hidden="true" />
          Send Email
        </a>

        <WatchPageTutorial
          videoKey="supportTickets"
          className="watch-page-tutorial--inline-left"
          buttonClassName="btn linear-gradient yr-add-new"
          buttonText={<>Watch Page Tutorial<i className="fa fa-play-circle ml-2" aria-hidden="true" /></>}
        />
      </div>
    </div>
  );
};

export default PlgSupportPage;
